import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

const useHardNavigate = () => {
  const navigate = useNavigate()

  const hardNavigate = useCallback(
    (targetPage: string) => {
      const normalizedTarget = targetPage.startsWith('/') ? targetPage : `/${targetPage}`

      navigate(normalizedTarget)
    },
    [navigate],
  )

  // The staging does not have /application/ pre in that url , so this code is not needed for now. Keeping it here for reference if we need to use full urls for routing in future.

  // {
  //   const match = currentUrl.match(/(\/application\/)[^?#]*/)
  //   if (match) {
  //     // Replace the URL after /application/ suffix
  //     const newUrl = currentUrl.replace(/(\/application\/)[^?#]*/, `$1${normalizedTarget.replace(/^\//, '')}`)
  //     window.location.assign(newUrl)
  //   } else {
  //     // Fallback if not in /application/ URL — just append
  //     const separator = currentUrl.endsWith('/') ? '' : '/'
  //     const newUrl = `${currentUrl}${separator}${normalizedTarget.replace(/^\//, '')}`
  //     window.location.assign(newUrl)
  //   }
  // }

  return hardNavigate
}

export default useHardNavigate
